import axios, {  AxiosRequestHeaders } from 'axios';

const axiosInstance = axios.create({
  baseURL:  "https://qw5ijwlg40.execute-api.ap-southeast-2.amazonaws.com/allinone",
  headers: {
    'Content-Type': 'application/json',
  },
});


axiosInstance.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('token');
  if (config.headers)
    (config.headers as AxiosRequestHeaders).set("Authorization", `Bearer ${token}`);
  return config;
},
(error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error.response.data);
  },
);

export default axiosInstance;